declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export const CHECKOUT_URL = 'https://apometry-en.impultienda.ar/checkout/';

export function trackCheckout(): void {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'InitiateCheckout', { value: 27, currency: 'USD' });
  }
}
